import { useEffect } from "react";

import Image from "next/image";
import { useRouter } from "next/navigation";

import { Button } from "antd";
import useTranslation from "next-translate/useTranslation";

import lock from "shared/assets/icons/Lock.svg";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import useMainPage from "shared/utils/hooks/useMainPage";

import { InvalidTokenWarningContainer } from "./styles";

function InvalidTokenWarning() {
  const router = useRouter();
  const mainPage = useMainPage();
  const { t } = useTranslation();
  const { setState } = useGlobalContext();

  useEffect(() => {
    setState((prev) => ({ ...prev, modal: { open: true, page: "login" } }));
  }, []);

  return (
    <InvalidTokenWarningContainer>
      <div className="card">
        <h1>
          <strong>{t("common:sessionExpired")}</strong>
        </h1>
        <div
          style={{ position: "relative", width: "64px", paddingBottom: "4%" }}
        >
          <Image src={lock} width={64} height={56} alt="card" />
        </div>
        <h3>{t("common:loggedOut")}</h3>

        <div className="buttons">
          <Button
            onClick={() => router.push(`/${mainPage}`)}
            className="back-to-plataform"
          >
            {t("common:backToPlatform")}
          </Button>
          <Button
            className="login"
            onClick={() => {
              setState((prev) => ({
                ...prev,
                modal: {
                  open: true,
                  page: "login",
                },
              }));
            }}
            type="primary"
          >
            {t("common:Login")}
          </Button>
        </div>
      </div>
    </InvalidTokenWarningContainer>
  );
}

export default InvalidTokenWarning;
